__turbopack_context__.v({
  "Root": "NGO4ha_Root",
  "Root--Square": "NGO4ha_Root--Square",
  "skeleton-loading": "NGO4ha_skeleton-loading",
});
